var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-truncate "
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm.hasOpenDetailListener() ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.firstName) + " " + _vm._s(_vm.item.lastName) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.firstName) + " " + _vm._s(_vm.item.lastName) + " ")])]), _c('v-spacer')], 1)]), !_vm.small ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate text-xs"
  }, [_vm.item.contact && _vm.item.contact.phone ? _c('span', [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-phone")]), _vm._v(" " + _vm._s(_vm.item.contact.phone) + " ")], 1) : _vm._e(), _vm.item.contact && _vm.item.contact.email ? _c('span', [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" " + _vm._s(_vm.item.contact.email) + " ")], 1) : _vm.item.userName ? _c('span', [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" " + _vm._s(_vm.item.userName) + " ")], 1) : _vm._e()]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }